import React from 'react';
import { StepWrapper } from '../StepWrapper';
import { Settings } from '@/pages/Settings';

interface StepPlannerDefaultsProps {
  onNext: () => void;
  onBack: () => void;
  onSkip: () => void;
}

export function StepPlannerDefaults({ onNext, onBack, onSkip }: StepPlannerDefaultsProps) {
  return (
    <StepWrapper
      onNext={onNext}
      onBack={onBack}
      onSkip={onSkip}
      nudgeMessage="These defaults affect how utilisation, forecasting, and resource matching behave across the planner. You can refine them at any time from Settings."
    >
      {/*
        embeddedMode hides the fixed Save/Cancel footer and the Search box
        that belong to the full-page Settings shell.
        hiddenTabs removes Resource Rates and Absence & Holiday — excluded
        from onboarding per spec.
      */}
      <div className="min-h-[600px] overflow-hidden">
        <Settings
          initialTab="settings"
          embeddedMode={true}
          hiddenTabs={['resource-rates', 'absence-holidays']}
        />
      </div>
    </StepWrapper>
  );
}
